import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";

import DateFormat from "../common/dateFormat/DateFormat";
import LabelAndInputNumber from "../common/form/labelAndInputNumber";
import AbasGraficosRefatorado from "./components/AbasGraficos";
import GraficoMes from "./components/GraficoMes";
import GraficoAno from "./components/GraficoAno";
import FiltroGraficoDia from "./components/FiltroGraficoDia";
import { montarGraficoDia } from "./components/graficosDia";
import { montarGraficoDiaFP } from "./components/graficoDiaFP";
import {
    setModoTela,
    setDataInicialGrafico,
    setDataFinalGrafico,
    getListaGraficoDia,
    getListaGraficoDiasMes,
    getListaGraficoMesesAno,
} from "./monitoramentoConsumoActions";

function GraficosPeQ({
    nomeGrafico,
    registro,
    dataInicialGrafico,
    dataFinalGrafico,
    listaGraficoDia,
    listaGraficoDiasMes,
    listaGraficoMesesAno,
    setModoTela,
    setDataInicialGrafico,
    setDataFinalGrafico,
    getListaGraficoDia,
    getListaGraficoDiasMes,
    getListaGraficoMesesAno,
    aguardando,
}) {
    const [grafico, setGrafico] = useState(null);
    const [graficoFP, setGraficoFP] = useState(null);
    const [zoomFP, setZoomFP] = useState(false);
    const [nomeGraficoAtivo] = useState("graficoDia");
    const [abaAtiva, setAbaAtiva] = useState("dia");
    const [tipoInformacao, setTipoInformacao] = useState("demanda");

    const [valorDescontoQ, setValorDescontoQ] = useState();
    const [simular, setSimular] = useState(false);
    const [simulacaoAtiva, setSimulacaoAtiva] = useState(false);

    const diferencaEmDias = (new Date(dataFinalGrafico) - new Date(dataInicialGrafico)) / (1000 * 60 * 60 * 24);
    const mensagemOcultacaoLinhaDemandas = diferencaEmDias > 62 ? "A linha que indica a demanda contratada só fica visível se filtrar um período máximo de 2 meses." : null;

    useEffect(() => {
        return () => desmontarTodosGraficos();
    }, []);

    useEffect(() => {
        if (abaAtiva !== "dia") desmontarTodosGraficos();
    }, [abaAtiva]);

    useEffect(() => {
        if (abaAtiva !== "dia") return;
        atualizarListasGraficos({ dataInicialGrafico, dataFinalGrafico, nomeGrafico });
    }, [abaAtiva, dataInicialGrafico, dataFinalGrafico, registro]);

    useEffect(() => {
        if (abaAtiva !== "dia") return;
        if (simulacaoAtiva) return;
        //só monta se já tiver a div com o id de referencia renderizado
        switch (nomeGraficoAtivo) {
            case "graficoDia":
                desmontarTodosGraficos();
                montarGraficoDia({ id: "graficoDia", lista: listaGraficoDia, diferencaEmDias, isMobile: window.innerWidth <= 768, setGrafico, registro });
                montarGraficoDiaFP({ id: "graficoDiaFP", lista: listaGraficoDia, zoomFP, isMobile: window.innerWidth <= 768, setZoomFP, setGraficoFP });
                break;
            default:
                break;
        }
    }, [abaAtiva, nomeGraficoAtivo, JSON.stringify(listaGraficoDia), zoomFP, simulacaoAtiva]);

    useEffect(() => {
        if (abaAtiva !== "dia") return;
        if (!simulacaoAtiva) return;
        switch (nomeGraficoAtivo) {
            case "graficoDia":
                desmontarTodosGraficos();
                const listaGraficoSimulada = listaGraficoDia.map((item) => ({
                    ...item,
                    q_simulado: new Date(item.data_hora).getTime() <= new Date().getTime() ? item.q - valorDescontoQ : null,
                }));
                montarGraficoDia({ id: "graficoDia", lista: listaGraficoSimulada, diferencaEmDias, isMobile: window.innerWidth <= 768, setGrafico, registro });
                montarGraficoDiaFP({ id: "graficoDiaFP", lista: listaGraficoSimulada, zoomFP, isMobile: window.innerWidth <= 768, setZoomFP, setGraficoFP });
                break;
            default:
                break;
        }
    }, [abaAtiva, simular, zoomFP, simulacaoAtiva]);

    if (abaAtiva !== "dia") {
        const GraficoModo = abaAtiva === "mes" ? GraficoMes : GraficoAno;
        return (
            <GraficoModo
                setAbaAtiva={setAbaAtiva}
                registro={registro}
                aguardando={aguardando}
                setModoTela={setModoTela}
                lista={abaAtiva === "mes" ? listaGraficoDiasMes : listaGraficoMesesAno}
                buscarLista={abaAtiva === "mes" ? getListaGraficoDiasMes : getListaGraficoMesesAno}
                tipoInformacao={tipoInformacao}
                setTipoInformacao={setTipoInformacao}
            />
        );
    }

    const readOnly = aguardando;
    return (
        <ContentCard style={{ backgroundColor: "#f0f1f5", paddingLeft: 0 }}>
            <ContentCardBody padding="0px">
                <Row style={{ height: "fit-content", paddingLeft: 15, paddingRight: 7 }}>
                    <Row
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            width: "100%",
                            backgroundColor: "#fff",
                            borderTop: "1px solid #ddd",
                            paddingTop: 25,
                            alignItems: "center",
                            justifyContent: window.innerWidth < 1340 ? "center" : "start",
                        }}
                    >
                        <Row style={{ width: "100%", justifyContent: "flex-end", paddingBottom: 10 }}>
                            <Grid cols="12 3 3 3">
                                <Button
                                    style={{ margin: 0 }}
                                    text="Voltar"
                                    type={"warning"}
                                    icon={"fa fa-chevron-left"}
                                    disabled={readOnly}
                                    event={() => {
                                        desmontarTodosGraficos();
                                        setModoTela("lista", {});
                                        setDataInicialGrafico(DateFormat.getDataAtual().replace(/\//g, "-"));
                                        setDataFinalGrafico(DateFormat.getDataAtual().replace(/\//g, "-"));
                                    }}
                                />
                            </Grid>
                        </Row>

                        <AbasGraficosRefatorado abaAtiva={abaAtiva} setAbaAtiva={setAbaAtiva} />

                        <FiltroGraficoDia
                            dataInicialGrafico={dataInicialGrafico}
                            dataFinalGrafico={dataFinalGrafico}
                            setDataInicialGrafico={setDataInicialGrafico}
                            setDataFinalGrafico={setDataFinalGrafico}
                            aguardando={readOnly}
                            mensagem={mensagemOcultacaoLinhaDemandas}
                        />

                        <Row
                            style={{
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                                paddingLeft: 20,
                                marginTop: 20,
                            }}
                        >
                            <LabelAndInputNumber
                                name="valor-desconto-q"
                                label="Digitar potência de capacitor a ser instalado"
                                placeholder="Digitar potência de capacitor a ser instalado"
                                cols="12 12 3 3"
                                casas={2}
                                disabled={readOnly}
                                allowNegative={true}
                                onChange={(e) => {
                                    const valorFormatado = parseFloat(e.target.value.replace(",", ".")) || 0;
                                    setValorDescontoQ(valorFormatado);
                                }}
                            />
                            <Grid cols="12 12 3 2" style={{ marginTop: 15 }}>
                                <Button
                                    text="Simular"
                                    type={"info"}
                                    icon={"fa fa-calculator"}
                                    disabled={readOnly}
                                    event={() => {
                                        setSimulacaoAtiva(true);
                                        setSimular(!simular);
                                    }}
                                />
                            </Grid>
                            <Grid cols="12 12 3 2" style={{ marginTop: 15 }}>
                                <Button
                                    text="Desfazer Simulação"
                                    type={"danger"}
                                    icon={"fa fa-undo"}
                                    disabled={readOnly}
                                    event={() => {
                                        setValorDescontoQ(null);
                                        setSimulacaoAtiva(false);
                                    }}
                                />
                            </Grid>
                        </Row>
                    </Row>

                    <div
                        id={`${nomeGrafico}`}
                        style={{
                            width: "100%",
                            backgroundColor: "#fff",
                            height: "400px",
                        }}
                    ></div>

                    <div
                        id={`${nomeGrafico}FP`}
                        style={{
                            width: "100%",
                            backgroundColor: "#fff",
                            height: "350px",
                        }}
                    ></div>
                </Row>
            </ContentCardBody>
        </ContentCard>
    );

    function atualizarListasGraficos({ dataInicialGrafico, dataFinalGrafico, nomeGrafico }) {
        if (!(registro.consumoLeitura || {}).id_consumo_integracao) return;
        const filtro = {
            id_consumo_integracao: registro.consumoLeitura.id_consumo_integracao,
            dataInicial: dataInicialGrafico,
            dataFinal: dataFinalGrafico,
        };
        switch (nomeGrafico) {
            case "graficoDia":
                getListaGraficoDia(filtro);
                break;
            default:
                break;
        }
    }

    function desmontarTodosGraficos() {
        if (grafico) {
            console.log("desmontando grafico");
            grafico.dispose();
        }
        if (graficoFP) {
            console.log("desmontando graficoFP");
            graficoFP.dispose();
        }
    }
}

const mapStateToProps = (state) => {
    return {
        aguardando: state.monitoramentoConsumo.aguardando,
        nomeGrafico: state.monitoramentoConsumo.modoTela,
        registro: state.monitoramentoConsumo.registro,
        dataInicialGrafico: state.monitoramentoConsumo.dataInicialGrafico,
        dataFinalGrafico: state.monitoramentoConsumo.dataFinalGrafico,
        listaGraficoDia: state.monitoramentoConsumo.listaGraficoDia,
        listaGraficoDiasMes: state.monitoramentoConsumo.listaGraficoDiasMes,
        listaGraficoMesesAno: state.monitoramentoConsumo.listaGraficoMesesAno,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            setDataInicialGrafico,
            setDataFinalGrafico,
            getListaGraficoDia,
            getListaGraficoDiasMes,
            getListaGraficoMesesAno,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(GraficosPeQ);
